import React, { FC } from 'react';
import { Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  footer: {
    padding: 48,
  },
}));

const FooterComponent: FC = () => {
  const classes = useStyles();

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      className={classes.footer}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://curiosity-driven.web.app/">
        好奇心ドリブン開発
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
};

export default FooterComponent;
